import { useMantineTheme } from '@mantine/core';

import { useMediaQuery } from './useMediaQuery';

export const useIsMdBreakpoint = () => {
  const mantineTheme = useMantineTheme();

  return useMediaQuery(`(min-width: ${mantineTheme.breakpoints.md}px)`);
};
